var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.931396,
    height: 23.828003,
    viewBox: "0 0 23.9314 23.828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M12.22 23.76C9.87 23.76 8.78 23.41 6.88 22.04C5.68 23.58 1.88 24.79 1.71 22.73C1.71 21.18 1.37 19.87 0.98 18.44C0.52 16.68 0 14.72 0 11.88C0 5.1 5.56 0 12.15 0C18.76 0 23.93 5.35 23.93 11.94C23.93 12.72 23.86 13.48 23.71 14.24C23.56 15 23.34 15.73 23.05 16.45C22.76 17.16 22.4 17.84 21.97 18.48C21.54 19.13 21.06 19.72 20.52 20.27C19.97 20.82 19.38 21.31 18.74 21.74C18.1 22.17 17.42 22.54 16.71 22.84C16 23.14 15.27 23.36 14.51 23.52C13.75 23.67 12.99 23.75 12.22 23.76ZM12.32 5.86C9.1 5.69 6.6 7.92 6.05 11.4C5.59 14.29 6.4 17.8 7.09 17.98C7.42 18.06 8.26 17.39 8.78 16.87C9.65 17.47 10.62 17.82 11.68 17.9C12.48 17.94 13.26 17.83 14.01 17.56C14.77 17.29 15.44 16.89 16.04 16.36C16.64 15.83 17.11 15.2 17.47 14.48C17.82 13.76 18.02 13.01 18.08 12.21C18.11 11.41 17.98 10.63 17.71 9.88C17.44 9.12 17.03 8.45 16.49 7.86C15.95 7.26 15.32 6.8 14.6 6.45C13.88 6.1 13.11 5.9 12.32 5.86Z",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMax);
export default __webpack_public_path__ + "static/media/ic_max.a32e11dd934ceb8ef716078847b15a49.svg";
export { ForwardRef as ReactComponent };